import axios, { AxiosInstance } from 'axios';
import store from '@/store';
import { ERROR_MSG, RETRYWAITINGTIME, ROUTE_NAME } from '@/utils/constant';
import router from '@/router';
import { isProdMode, getBaseUrl } from '@/utils/helpers';

axios.defaults.timeout = RETRYWAITINGTIME; // default timeout

// Detect environment: use production if prod=true in URL, otherwise use NODE_ENV
const isProduction = isProdMode() || process.env.NODE_ENV === 'production';




// const getBaseUrl = () => {
//   const hostName = window.location.hostname;

//   if (hostName.startsWith('www.')) {
//     return hostName.slice(4);
//   }

//   // Fallback for other patterns or special cases
//   const hostNameArr = hostName.split('.');
//   if (hostName.includes('dg8-api') || hostName.includes('gc-dev') || hostName === 'localhost') {
//     return isProduction ? 'ga28-api.com' : 'ga28.cc';
//   }

//   if (hostNameArr.length >= 2) {
//     if (hostNameArr.length === 2) return hostName;
//     return `${hostNameArr[hostNameArr.length - 2]}.${hostNameArr[hostNameArr.length - 1]}`;
//   }

//   return isProduction ? 'ga28-api.com' : 'ga28.cc';
// };

const baseServer = getBaseUrl();
// Set the base URL according to the environment
axios.defaults.baseURL = `https://${isProduction ? 'api' : 'gc-api-dev'}.${baseServer}/api/v1/`;

// Log the current mode
// console.log('API Mode:', isProduction ? 'PRODUCTION' : 'DEVELOPMENT');
// console.log('Base URL:', axios.defaults.baseURL);

// GLOBAL RESPONSE HANDLER
const responseHandler = (res: any) => {
  if (res.status === 200 || res.status === 201) {
    return Promise.resolve(res);
  } else {
    return Promise.reject(res);
  }
};

// GLOBAL RESPONSE ERROR HANDLER
const responseErrorHandler = async (error: any, server: AxiosInstance) => {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        if (error.response?.data?.message?.includes('login required')) {
          router.push({ name: ROUTE_NAME.sessionExpired });
        }
        break;
      case 401:
        if (window.location.pathname !== '/launch.html' && window.location.pathname !== '/launch') {
          router.push({ name: ROUTE_NAME.sessionExpired });
        }
        break;
      case 403:
        break;
      case 404:
        return Promise.resolve(error.response);
        break;
      case 408:
        if (error.config.method !== 'post') {
          return server.request(error.config); // recall same request from config
        }
      case 500:
      case 502:
        error.response['base_code'] = 0;
    }

    // Determine structured error group and code
    // Group 2 = backend error (response body has {"code": <number>})
    // Group 3 = network/infrastructure error (no structured backend code)
    const responseData = error.response.data;
    const hasBackendCode =
      responseData &&
      typeof responseData === 'object' &&
      !Array.isArray(responseData) &&
      typeof responseData.code === 'number';

    if (hasBackendCode) {
      error.response['_errorGroup'] = 2;
      error.response['_errorCode'] = responseData.code;
    } else {
      error.response['_errorGroup'] = 3;
      error.response['_errorCode'] = error.response.status;
    }

    return Promise.reject(error.response);
  } else if (error && error.code === 'ECONNABORTED' && error.message.indexOf('ms exceeded') > 1) {
    // Timeout error: group 3, code 1
    if (error.config.method !== 'post') {
      return server.request(error.config);
    } else {
      store.dispatch('menu/updateMenu', {
        isErrorPopupOpen: true,
        errorHeading: 'Timeout Error',
        errorMsg: 'TIMEOUT_ERROR_MESSAGE',
      });
      return Promise.reject({
        _errorGroup: 3,
        _errorCode: 1,
        data: {
          base_code: 3,
          code: 0,
          ref_code: 0,
        },
      });
    }
  } else {
    // Network error (DNS, connection refused, etc.): group 3, code 2
    store.dispatch('menu/updateMenu', {
      isErrorPopupOpen: true,
      errorHeading: 'Network Error',
      errorMsg: 'NETWORK_ERROR_MESSAGE',
    });
    return Promise.reject({
      _errorGroup: 3,
      _errorCode: 2,
      data: {
        base_code: 0,
        code: 0,
        ref_code: 0,
      },
    });
  }
};

axios.interceptors.response.use(
  (res: any) => responseHandler(res),
  (error: any) => responseErrorHandler(error, axios)
);

// Export the current environment mode as well
export const isProductionMode = isProduction;
export default axios;
